<template>
  <div id="news_detail">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/bg3.jpg'); height:50vh">
        <div class="container">
            <div class="row">
              <div class="col-md-8 ml-auto mr-auto">
                  <div class="brand text-center">
                    <!-- <h1 class="title">{{ time }}</h1> -->
                    <h3 class="title description" id="hide_edit" @click="edit_news_detail(id, time, title, parag)">{{ title }}</h3>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <div class="main">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/news"><b>最新消息</b></router-link>
          </li>
          <li class="breadcrumb-item"><b>{{ time }}</b></li>
          <li class="breadcrumb-item" aria-current="page"><b>{{ title }}</b></li>
        </ol>
        <div class="container">
          
          <div class="section">
            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
              <ol class="carousel-indicators">
                <template v-for="(item, index) in img">
                  <li v-if="index == 0" :key="index" data-target="#carouselExampleIndicators" :data-slide-to="index" class="active"></li>
                  <li v-else :key="index" data-target="#carouselExampleIndicators" :data-slide-to="index"></li>
                </template>
              </ol>
              <div class="carousel-inner" style="background-color: black">
                <template v-for="(item, index) in img">
                  <div v-if="index == 0" :key="index" class="carousel-item active">
                    <img class="d-block w-100" :src="item.img" alt="First slide">
                  </div>
                  <div v-else :key="index" class="carousel-item">
                    <img class="d-block w-100" :src="item.img" alt="First slide">
                  </div>
                </template>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>

            <div class="mt-5" style="white-space:pre-wrap; word-wrap: break-word;">
              <b>{{ parag }}</b>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "news_detail",
  props: ['id', 'title', 'time','parag'],
  data() {
    return {
      img:[],
    };
  },
  methods: {
    getImg: function(){
      var vm = this;
      axios
        .post(`/api/getnewsImg`,{
          pid: vm.id
        })
        .then(res => {
          vm.img = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    edit_news_detail: function(id, time, title, parag){
      var vm = this;
        document.querySelector('#hide_edit').addEventListener('click', function (evt) {
            if(evt.detail === 3){
                vm.$router.push({ name: 'edit_news_detail', params: { id: id, time: time, title: title, parag: parag } }).catch(error => {
                    if (error.name != "NavigationDuplicated") {
                        throw error;
                    }
                });
            }
        });
    },


  },
  filters: {},
  computed: {},
  created() {
    this.getImg();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/news_detail.vue